// @flow

import { TASK_INSTANCE_COMPLETED_STATUS } from 'sling-calendar-sdk/constants';

import type { Subtask } from '../../common/typings';

export default function hasAllSubtasksCompleted(subtasks: Array<Subtask>): boolean {
  return subtasks.every(subtask => subtask.status === TASK_INSTANCE_COMPLETED_STATUS);
}
